import { put, takeLatest } from 'redux-saga/effects';
import { setSignedIn } from 'redux/reducers/authorization';
import { setSession } from "redux/reducers/session";
import { setAuth } from "services/AuthService";

export const SAGA_USER_SIGNED_IN = 'SAGA_USER_SIGNED_IN';

export function userSignedInAction(session) {
  return { type: SAGA_USER_SIGNED_IN, payload: session };
}

export function* store_session_and_mark_user_signed_in(action) {
  setAuth(JSON.stringify(action.payload));
  yield put(setSession(action.payload));
  yield put(setSignedIn);
}

export function* watchForUserSignedIn() {
  yield takeLatest(SAGA_USER_SIGNED_IN, store_session_and_mark_user_signed_in);
}
